import { isNullish, LocalDateString, TimeZoneId } from '../../common'
import { BzDateTime } from '../DateTime/BzDateTime'

// NOTE: Pure sorcery. This is a blend of ChatGPTs report on the least busy months,
// and the interweaving to space the visit apart when they are more than 1.
export const defaultAffinityMonthsNumbersJs = [9, 3, 6, 0, 8, 2, 10, 4, 11, 1, 5, 7]

/**
 * Returns the name of the month for a given index in the defaultAffinityMonthsNumbersJs array.
 *
 * @param index - The index in the defaultAffinityMonthsNumbersJs array
 * @returns The name of the month (e.g., "January", "February", etc.)
 */
export const getMonthNameByAffinityIndex = (index: number): string => {
  const monthIndex = defaultAffinityMonthsNumbersJs[index % 12]
  // 2000 is just a random year
  const date = new Date(2000, monthIndex, 1)
  return date.toLocaleString('en-US', { month: 'long' })
}

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const getBufferForNumVisits = (numVisits: number): number => {
  if (numVisits < 1) return 6

  switch (numVisits) {
    case 1:
      return 6
    case 2:
      return 4
    case 3:
      return 3
    case 4:
      return 2
    default:
      return 1
  }
}

export const getEarliestEligibleMonthIndex = (
  numVisitCreditsPerYear: number,
  fromActivationDate: LocalDateString,
  tzId: TimeZoneId,
) => {
  const activationDate = BzDateTime.fromDateString(fromActivationDate, tzId)
  const activationMonth = activationDate.toDate().getMonth()
  const buffer = getBufferForNumVisits(numVisitCreditsPerYear)
  return (activationMonth + buffer) % 12
}

export const getAffinityDateByVisitIndex = (
  visitIndex: number,
  fromActivationDate: LocalDateString,
  tzId: TimeZoneId,
  plusYears: number = 0,
  affinityMonthIndex?: number,
): LocalDateString => {
  const activationDate = BzDateTime.fromDateString(fromActivationDate, tzId)
  const activationMonth = activationDate.toDate().getMonth()
  const activationYear = activationDate.toDate().getFullYear()
  const baseYear = activationYear + plusYears
  const nextYear = baseYear + 1
  const month = !isNullish(affinityMonthIndex) ? affinityMonthIndex : defaultAffinityMonthsNumbersJs[visitIndex % 12]
  const year = month <= activationMonth || month > 11 ? nextYear : baseYear

  return getLocalDateForMonth(month % 12, year)
}

export const getLocalDateForMonth = (month: number, year: number): LocalDateString => {
  return `${year}-${(month + 1).toString().padStart(2, '0')}-01` as LocalDateString
}
